'use client';

import React from 'react';
import Link from 'next/link';

const Hero: React.FC = () => {
  return (
    <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 bg-[#FAFAFA]">

      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">

          {/* Text Content */}
          <div className="flex-1 text-center lg:text-left z-20">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border border-violet-100 text-violet-700 text-xs font-bold uppercase tracking-wide mb-8 shadow-sm animate-fade-in-up">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-violet-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-violet-500"></span>
              </span>
              Built for modern brands
            </div>

            <h1 className="text-5xl lg:text-7xl font-display font-bold tracking-tight text-slate-900 leading-[1.1] mb-6">
              Turn QR scans <br/>
              into <span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-600 via-fuchsia-500 to-indigo-600">opt‑in customer relationships</span>
            </h1>

            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed">
              Brand‑safe QR campaigns customers actually complete. Capture first‑party data through lightweight mini‑games, then use points and rewards to bring them back—without feeling like gambling.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <Link
                href="/register"
                className="w-full sm:w-auto px-6 py-3 rounded-full font-semibold transition-all duration-300 flex items-center justify-center gap-2 transform active:scale-95 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white shadow-xl shadow-violet-500/20 hover:shadow-violet-500/50 hover:-translate-y-1"
              >
                Start for Free
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" /></svg>
              </Link>
              <button className="w-full sm:w-auto px-6 py-3 rounded-full font-semibold transition-all duration-300 flex items-center justify-center gap-2 bg-white text-gray-700 border border-gray-200 hover:border-violet-200 shadow-md hover:bg-gray-50">
                <svg className="w-5 h-5 text-violet-600" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
                Watch the product tour
              </button>
            </div>

            <div className="mt-10 flex flex-wrap items-center justify-center lg:justify-start gap-3 border-t border-gray-200/60 pt-8">
              {[
                "Opt‑in lead capture",
                "Brand‑safe mini‑games",
                "Campaign analytics",
                "Loyalty & rewards",
              ].map((pill) => (
                <span
                  key={pill}
                  className="inline-flex items-center rounded-full bg-white px-4 py-2 text-sm font-semibold text-slate-800 ring-1 ring-slate-200 shadow-sm"
                >
                  {pill}
                </span>
              ))}
            </div>
          </div>

          {/* Visual Content - Floating Elements */}
          <div className="hidden lg:flex flex-1 relative w-full h-[500px] lg:h-[600px] items-center justify-center perspective-1000">

             {/* Main Dashboard Image */}
             <div className="relative z-20 w-[92%] max-w-xl animate-float transform rotate-y-12">
               <img
                 src="/dashboardmock.png"
                 alt="GameIt dashboard preview"
                 className="w-full h-auto rounded-2xl shadow-2xl border border-white/60"
                 draggable={false}
               />
             </div>

             {/* Phone Overlay (mobile view) */}
             <div className="absolute -right-6 bottom-10 z-30 w-[240px] md:w-[260px] animate-float-delayed">
               <img
                 src="/gameplay.png"
                 alt="GameIt mobile gameplay preview"
                 className="w-full h-auto rounded-2xl shadow-2xl border border-white/60"
                 draggable={false}
               />
             </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
